/* @flow */
import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import Text from 'components/Text.jsx';

type Props = {
  shareToken: string,
  showToast: (text: string, kind: 'success' | 'error') => void,
  orgType: string,
  orgName: string,
};

const AdminUpgradeShareQuoteBanner = ({ shareToken, showToast, orgType, orgName }: Props) => {
  const trackingPrefix = 'admin_self_serve.review_quote';

  const track = (key: string) => {
    EventTracking.trackKey(`${trackingPrefix}.${key}`);
  };

  const shareLink = `https://www.remind.com/admin_upgrade/quote/${shareToken}`;
  const emailSubject = encodeURIComponent(`Remind ${orgType} Plan Quote for ${orgName}`);
  const emailBody = encodeURIComponent(
    `I've created a Remind ${orgType} Plan quote for ${orgName}.

You can view the quote here: ${shareLink}

Teachers use Remind to reach students and parents with quick, simple text messages. Remind ${orgType} Plans help administrators get everyone involved (rostering and analytics) and protect their communities (documentation and controls). Upgrading to a Remind ${orgType} Plan also makes meaningful communication easier for everyone in the community (voice calls, longer messages, and more).

You can learn more about Remind ${orgType} Plans at https://www.remind.com/plans`
  );
  const emailLink = `mailto:?subject=${emailSubject}&body=${emailBody}`;

  return (
    <Text element="div" size="medium" weight="semibold">
      <span>Share this quote by &nbsp;</span>
      <CopyToClipboard
        text={shareLink}
        onCopy={() => showToast('Link copied to clipboard!', 'success')}>
        <Link onClick={() => track('copy_link.click')}>
          <Glyph name="link" size="medium" solo />
          <span> copying the link</span>
        </Link>
      </CopyToClipboard>
      <span>&nbsp; or &nbsp;</span>
      <Link href={emailLink} onClick={() => track('email_link.click')}>
        <Glyph name="email-stroke" size="medium" solo />
        <span> emailing it.</span>
      </Link>
    </Text>
  );
};

export default AdminUpgradeShareQuoteBanner;
